export function Card({ className = "", title, subtitle, action, children }) {
  return (
    <section className={`dash-card ${className}`.trim()}>
      {(title || subtitle || action) && (
        <header className="dash-card__head">
          <div>
            {title && <h3 className="dash-card__title">{title}</h3>}
            {subtitle && <p className="dash-card__sub">{subtitle}</p>}
          </div>
          {action}
        </header>
      )}
      <div className="dash-card__body">{children}</div>
    </section>
  );
}
